import { render } from "./discard-modal.vue?vue&type=template&id=08e06e70&ts=true"
import script from "./discard-modal.vue?vue&type=script&lang=ts"
export * from "./discard-modal.vue?vue&type=script&lang=ts"

import "./discard-modal.vue?vue&type=style&index=0&id=08e06e70&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__